// features/counter/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const detailsSlice = createSlice({
  name: 'details',
  initialState: {
    userDetails: {
      name: '',
      dob: '',
      timeOfBirth: '',
      placeOfBirth: '',
    },
    visitedUserDetails: false, // Flag to check if user details have been visited
  },
  reducers: {
    updateDetails: (state, action) => {
      console.log('Updating user details:', action.payload);
      state.userDetails = action.payload;
    },
    updateVisitedUserDetails: (state, action) => {
      console.log('Updating visited user details:', action.payload);
      state.visitedUserDetails = action.payload;
    },
  },
});

export const { updateDetails, updateVisitedUserDetails } = detailsSlice.actions;
export default detailsSlice.reducer;
